import hello from 'hellojs';
import { v4 as uuid } from 'uuid';
import hint from '@/api/rest/hint';
import { getSignInAuth, getSignUpAuth } from '@/config/auth';
import { MismatchedProviderError, ServerError } from './errors';
import throwClientError from './helpers/throwClientError';
function toSsoUsername(email) {
    return email.toLowerCase()
        .replaceAll('_at_', '_at__at_') // escape escape-sequence
        .replaceAll('@', '_at_') // escape @
        .concat('@xylem.idp.devicepilot.com'); // namespace
}
export async function signInWithXylem() {
    const xylem = hello('xylem');
    await xylem.login({ scope: 'basic' });
    const { access_token: token } = xylem.getAuthResponse();
    if (!token) {
        // this shouldn't happen
        throw new ServerError(new Error('Unable to connect to Xylem oAuth'));
    }
    const data = await xylem.api('userinfo');
    return { email: data.email, token };
}
async function attemptSignIn({ email, token }) {
    const challenge = await getSignInAuth().signIn(toSsoUsername(email));
    return getSignInAuth().sendCustomChallengeAnswer(challenge, token);
}
async function attemptSignUpAndIn(xylem) {
    let { email } = xylem;
    email = toSsoUsername(email);
    await getSignUpAuth().signUp({
        username: email,
        password: uuid(),
        attributes: {
            email,
            'custom:provider:name': 'xylem',
        },
    });
    return attemptSignIn(xylem);
}
export default async function authoriseWithXylem() {
    try {
        const xylem = await signInWithXylem();
        const { email } = xylem;
        const { exists, provider } = await hint(toSsoUsername(email));
        if (!exists) {
            await attemptSignUpAndIn(xylem);
            return {};
        }
        if (provider !== 'xylem') {
            throw new MismatchedProviderError('xylem');
        }
        await attemptSignIn(xylem);
        return {};
    }
    catch (error) {
        return throwClientError(error, { provider: 'xylem' });
    }
}
